import useMuteStore from '@module/stores/useMuteStore';
import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  isMuteOffMessage,
  isMuteOnMessage,
  type MuteOffMessage,
  type MuteOnMessage,
} from '@module/types/centrifuge/public-message/muteMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class MuteOnHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<MuteOnMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isMuteOnMessage(payload);
  }

  handle(payload: MuteOnMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setMuteOnMessages?.([...useMuteStore.getState().muteOnMessages, payload]);

    if (payload.data.message.idx === context.userInfo?.idx) {
      context.setMuteTime?.(payload.data.message.muteTime || 0);
    }
  }
}

export class MuteOffHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<MuteOffMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isMuteOffMessage(payload);
  }

  handle(payload: MuteOffMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    if (payload.data.message.idx === context.userInfo?.idx) {
      context.setMuteTime?.(0);
    }
  }
}
